import React from "react";

// region imports - Languages
import { FilterMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";
// endregion imports - Languages
// region imports - Libraries
import { Close, Search } from "@libraries/mui/icons";
import { IconButton, InputAdornment, TextField } from "@libraries/mui/components";
// endregion imports - Libraries

// region Interfaces
export interface IProps {
  onSearchClick: (text: string) => void;
  onClearClick: () => void;
  fieldLabel?: string;
}
// endregion Interfaces

const SearchField: React.FC<IProps> = ({ onSearchClick, onClearClick, fieldLabel }) => {

  // region Refs
  const textFieldRef = React.createRef<HTMLInputElement>();
  // endregion Refs

  // region Hooks
  const { t } = useTranslation();
  // endregion Hooks

  // region States
  const [textValue, setTextValue] = React.useState<string>("");
  // endregion States

  // region Functions
  const setTextFieldFocus = () => {
    textFieldRef.current?.focus();
  };
  // endregion Functions

  return (
    <TextField
      label={fieldLabel ?? t(FilterMessages.labelFilterDataOnScreen)}
      inputRef={textFieldRef}
      variant="outlined"
      onFocus={(ev) => ev.target.select()}
      onKeyDown={(ev) => {
        if (ev.key === "Enter") {
          onSearchClick(textValue);
        }
      }}
      size="small"
      fullWidth
      autoComplete="off"
      value={textValue}
      onChange={(ev) => setTextValue(ev.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {textValue !== "" && (
              <IconButton
                aria-label="clear filter"
                onClick={() => {
                  setTextValue("");
                  setTextFieldFocus();
                  onClearClick();
                }}
                onMouseDown={(evt) => evt.preventDefault()}
                edge="end"
              >
                <Close fontSize="small" />
              </IconButton>
            )}
            <IconButton
              aria-label="apply filter"
              onClick={() => {
                onSearchClick(textValue);
                setTextFieldFocus();
              }}
              onMouseDown={(evt) => evt.preventDefault()}
              edge="end"
            >
              <Search fontSize="small" />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

SearchField.defaultProps = {
  fieldLabel: undefined
};

export default SearchField;
